// extracted by mini-css-extract-plugin
export default {"feed":"OrdersFeed_feed__OSB-+","orders":"OrdersFeed_orders__QZ1Sj"};